import axios from 'axios';

import { API_BASE_URL } from '@config';

// SET
export const SET_CPUAVG = 'SET_CPUAVG';
export const setCpuAvg = d => ({
	type: SET_CPUAVG,
	payload: d
});


// * ////////////// GET ////////////// * //
export const getCpuAvg = params => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/loadavg`);
	
	return request
		.then(response => {
			dispatch(setCpuAvg({data: response.data}));
		});
};

